import { useAuth } from '../contexts/auth-context';

// Mobile bottom bar — four destinations, matching Header.jsx.
//
// Previously this could render six items, which pushed each target below the
// 44px minimum and truncated the labels. Four fit comfortably on a 360px screen.
// Styling lives in global.scss (.bottom-nav) because it needs the safe-area inset
// and a media query.

export default function BottomNav({ view, onNavigate }) {
  const { loggedIn, transponders } = useAuth();
  const hasTransponders = loggedIn && transponders.length > 0;

  return (
    <nav className="bottom-nav" aria-label="Hoofdnavigatie">
      <BottomNavBtn active={view === 'home'} onClick={() => onNavigate('home')} label="Baan" icon={<IconHome />} />
      <BottomNavBtn active={view === 'live'} onClick={() => onNavigate('live')} label="Live" icon={<IconLive />} />
      <BottomNavBtn
        active={view === 'ranking'}
        onClick={() => onNavigate('ranking')}
        label="Ranglijst"
        icon={<IconTrophy />}
      />
      {hasTransponders && (
        <BottomNavBtn
          active={view === 'myseason'}
          onClick={() => onNavigate('myseason')}
          label="Mijn ritten"
          icon={<IconSnowflake />}
        />
      )}
      <BottomNavBtn
        active={view === 'profile' || view === 'coach'}
        onClick={() => onNavigate('profile')}
        label="Profiel"
        icon={<IconPerson />}
      />
    </nav>
  );
}

function BottomNavBtn({ active, onClick, label, icon }) {
  return (
    <button
      className={`bottom-nav-btn${active ? ' active' : ''}`}
      onClick={onClick}
      aria-current={active ? 'page' : undefined}
    >
      <span className="bottom-nav-icon" aria-hidden="true">
        {icon}
      </span>
      {label}
    </button>
  );
}

function IconHome() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" />
      <polyline points="9 21 9 12 15 12 15 21" />
    </svg>
  );
}

// Live-uitzending: puntbron met golven. Zelfde beeldtaal als de stip op het
// live-bord zelf.
function IconLive() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" fill="currentColor" />
      <path d="M6.3 6.3a8 8 0 0 0 0 11.4" />
      <path d="M17.7 6.3a8 8 0 0 1 0 11.4" />
      <path d="M9.2 9.2a4 4 0 0 0 0 5.6" />
      <path d="M14.8 9.2a4 4 0 0 1 0 5.6" />
    </svg>
  );
}

function IconTrophy() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 21h8M12 21v-4" />
      <path d="M7 4H4a1 1 0 0 0-1 1v3c0 2.21 1.79 4 4 4" />
      <path d="M17 4h3a1 1 0 0 1 1 1v3c0 2.21-1.79 4-4 4" />
      <path d="M7 4h10v7a5 5 0 0 1-5 5 5 5 0 0 1-5-5V4z" />
    </svg>
  );
}

function IconSnowflake() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2v20M4.2 7l15.6 10M19.8 7L4.2 17" />
      <path d="M12 6l-2.2-2.2M12 6l2.2-2.2M12 18l-2.2 2.2M12 18l2.2 2.2" />
    </svg>
  );
}

function IconPerson() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 3.58-7 8-7s8 3 8 7" />
    </svg>
  );
}
